var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"form justify-center"},[_c('div',{staticStyle:{"width":"30%"},on:{"keyup":function($event){if(!$event.shiftKey){ return null; }return _vm.alert('hello')}}},[_c('login-form')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }